/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** Ages below this are treated as a minor. */
export const MINOR_AGE_YEARS = 18

/** Confidence at or above this means the scanner detected a minor. */
export const MINOR_SCORE_THRESHOLD = 0.8

export const demographicIndicatesMinor = (scan: {
  ageEstimation?: number | null
  minorScore?: number | null
}): boolean => {
  const age = scan.ageEstimation
  if (typeof age === 'number' && Number.isFinite(age) && age < MINOR_AGE_YEARS) {
    return true
  }

  const minorScore = scan.minorScore
  return typeof minorScore === 'number' && Number.isFinite(minorScore) && minorScore >= MINOR_SCORE_THRESHOLD
}
